import { ITemplateFilterParams } from '@/services/common';
import { ISearch } from '@/services/templateCenter';
import { create } from 'zustand';

type FilterParamsTypes = Partial<ISearch> & {
  group_code?: string;
  module_list?: string;
  // status: 0 | 1 | 2 | '0,1,2' | undefined;
  size: number;
  group_type: 0; // 暂定写死过滤
};

type FilterStore = {
  params: FilterParamsTypes;
  setParams: (newParams: Partial<FilterParamsTypes>) => void;
  resetParams: () => void;
};

const defaultParams: FilterParamsTypes = {
  // group_code: '',
  // module_list: undefined,
  // status: '0,1,2',
  size: 50,
  group_type: 0,
};

const useCustomFilterStore = create<FilterStore>((set) => ({
  params: defaultParams,
  setParams: (newParams) =>
    set((state) => ({
      params: {
        ...state.params,
        ...newParams,
      },
    })),
  resetParams: () => set({ params: defaultParams }),
}));

export default useCustomFilterStore;
